import { RouterState } from "@ngrx/router-store";
import { Auth } from "../../auth/primitives/auth";

export interface NetworkState {
  previousConnectedValue: boolean;
  isConnected: boolean;
  isSlow: boolean;
  isNoResponse: boolean;
  sockets: string[]
  allSocketsConnected: boolean;
  networkEnabled: boolean;
}

export const initialState: NetworkState = {
  previousConnectedValue: false,
  isConnected: false,
  isSlow: false,
  isNoResponse: false,
  sockets: [],
  allSocketsConnected: false,
  networkEnabled: false
};
